import { AssetLoader, AudioBus, resolveEntryUrl } from '@goodtime/engine';
import { ROAD_AUDIO } from '../../themes';
import { BUTTON_PLATES, ROAD_GAMES, roadGamesFor } from '../../themes/roadGames';

/** The road's sounds, fetched once for every game. */
let roadAudio: Promise<void> | null = null;

/**
 * A mini-game's art (with a world's own pieces on its slot, `themeId`), the
 * plates its buttons sit on, and the road's sounds its game plays (once).
 * Fetched when the game first opens, while its title card plays, on any
 * slot or the realm map: a slot without the road has none of them loaded.
 */
export async function loadGameArt(kind: string, themeId?: string): Promise<void> {
  const pieces = (themeId ? roadGamesFor(themeId) : ROAD_GAMES)[kind] ?? {};
  const entries = [...Object.values(pieces), ...Object.values(BUTTON_PLATES)].flatMap((e) => {
    const src = resolveEntryUrl(e) ?? e.src;
    return src ? [{ alias: e.alias, src }] : [];
  });
  roadAudio ??= Promise.all(
    Object.values(ROAD_AUDIO).map((e) => {
      const src = resolveEntryUrl(e) ?? e.src;
      return src ? AudioBus.shared.loadEntry(e.alias, src).catch(() => undefined) : undefined;
    }),
  ).then(() => undefined);
  await Promise.all([AssetLoader.shared.loadTextures(entries).catch(() => undefined), roadAudio]);
}
